import { Button, Stack, Typography, useTheme } from "@mui/material";
import { Check, Plus } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PaperworkStepLayout } from "web_myplann/Profile/Components/Paperwork/PaperworkStepLayout";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

const R = Resources.Paperwork.Upload.Success;

type Props = {
	typeName: string;
	reminderSet: boolean;
	mode?: "create" | "update";
	onViewDocuments: () => void;
	onAddAnother: () => void;
	onBack: () => void;
};

export const PaperworkSuccessStep: FC<Props> = ({
	typeName,
	reminderSet,
	mode = "create",
	onViewDocuments,
	onAddAnother,
	onBack,
}) => {
	const { palette } = useTheme();
	const { t } = useResource();
	const isUpdate = mode === "update";
	const title = t(isUpdate ? R.updateTitle : R.title);
	const description = t(isUpdate ? R.updateDescription : R.description, {
		name: typeName,
	});

	return (
		<PaperworkStepLayout title={title} onBack={onBack} center>
			<Stack alignItems="center" textAlign="center" px={2.4} py={4}>
				<IconBox bg={palette.green[100]} size={64} shape="circle" mb={1.6}>
					<Check size={32} color={palette.green[600]} />
				</IconBox>
				<Typography variant="h2" mb={0.8}>
					{title}
				</Typography>
				<Typography variant="body2" mb={0.4}>
					{description}
				</Typography>
				<Typography variant="hint" mb={3.2}>
					{reminderSet ? t(R.reminderSet) : t(R.expiryNote)}
				</Typography>

				<Stack width="100%" gap={1.2}>
					<Button variant="primary" fullWidth onClick={onViewDocuments}>
						{t(isUpdate ? R.viewDocument : R.viewInWallet)}
					</Button>
					{!isUpdate && (
						<Button
							variant="secondary"
							fullWidth
							startIcon={<Plus size={16} />}
							onClick={onAddAnother}
						>
							{t(R.addAnother)}
						</Button>
					)}
					<Button variant="textLink" fullWidth onClick={onBack}>
						{t(R.back)}
					</Button>
				</Stack>
			</Stack>
		</PaperworkStepLayout>
	);
};
